import MediaQueries from './MediaQueries'

const ContentLimits: Record<MediaQueries, string> = {
  [MediaQueries.Tablet]: '691px',
  [MediaQueries.LaptopSmall]: '834px',
  [MediaQueries.LaptopLarge]: '964px',
  [MediaQueries.Desktop]: '964px'
}

export default ContentLimits
